import axios from "axios";
import { useState, useEffect, useCallback } from "react";
import { Card } from "ktm-ui";
import { Modal, Spinner, Table } from "react-bootstrap";
import toastr from "toastr";
import moment from "moment";
import CustomPagination from "components/CustomPagination";
import "../../styles/Campaign.css";
import BulkEditEmployeeBenCatCampaignModal from "../../components/Bulk_edit_employee_bencat_campaign";
import EditIndividualEmpCampaignModal from "../../components/Edit_individual_emp_campaign";
import BulkEditEmployeeDeadlineCampaignModal from "../../components/Bulk_edit_employee_deadline_campaign";
import CustomToolTip from "components/CustomToolTip";
import React from "react";

const EmployeeCampaignTable = ({ policy_id, benefitEndDate, disableBtn, selectionDeadline, launchDate, HasAccrual, readOnly }) => {
    const [loading, setLoading] = useState(true);
    const [employeeCampaignDetails, setEmployeeCampaignDetails] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(20);
    const [hasSalaryBaseBenefits, setHasSalaryBaseBenefits] = useState(false);
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [showBulkEditEmployeeBenCatCampaignModal, setShowBulkEditEmployeeBenCatCampaignModal] = useState(false);
    const [showBulkEditEmployeeDeadlineCampaignModal, setShowBulkEditEmployeeDeadlineCampaignModal] = useState(false);
    const [showEditIndividualEmpCampaignModal, setShowEditIndividualEmpCampaignModal] = useState(false);
    const [showSendFlexSelectionModal, setShowSendFlexSelectionModal] = useState(false);
    const [showAcknowledgmentModal, setShowAcknowledgmentModal] = useState(false);
    const [selectedEmpBenCat, setSelectedEmpBenCat] = useState(null);
    const [selectedEmpFlexSelectionDeadline, setSelectedEmpFlexSelectionDeadline] = useState(null);
    const [selectedIndividualEmployee, setSelectedIndividualEmployee] = useState(null);
    const [bencatOptions, setBencatOptions] = useState([]);
    const [isEmployeeUpdated, setIsEmployeeUpdated] = useState(false);
    const [sortConfig, setSortConfig] = useState([]);

    const fetchEmployeeCampaigns = useCallback(async () => {
        try {
            const response = await fetch(`/api/Flex/getemployeecampaigns?PolicyId=${policy_id}`);
            const data = await response.json();
            if (data.success) {
                setEmployeeCampaignDetails(data.employeeCampaigns);
                setHasSalaryBaseBenefits(data.hasSalaryBaseBenefits);
                setLoading(false);
            }
        } catch (error) {
            toastr.error("Failed to fetch employee campaigns", "Error");
        }
    }, [policy_id]);

    const fetchBenefitCategories = useCallback(async () => {
        try {
            const response = await fetch(`/api/Utility/getnextyearbenefitcategories?policyId=${policy_id}`);
            const data = await response.json();
            if (data.success) {
                setBencatOptions([{ Id: null, name: "--Select--", CreditCalcMethod: null }, ...data.benefitCategories]);
            }
        } catch (error) {
            toastr.error("Failed to fetch benefit categories", "Error");
        }
    }, [policy_id]);

    useEffect(() => {
        setLoading(true);
        fetchEmployeeCampaigns();
        fetchBenefitCategories();
    }, [fetchEmployeeCampaigns, fetchBenefitCategories]);

    useEffect(() => {
        if (isEmployeeUpdated) {
            fetchEmployeeCampaigns();
            setIsEmployeeUpdated(false);
        }
    }, [isEmployeeUpdated, fetchEmployeeCampaigns]);

    useEffect(() => {
        fetchEmployeeCampaigns();
    }, [selectionDeadline, benefitEndDate, fetchEmployeeCampaigns]);

    const handleSelectAll = () => {
        if (selectedEmployees.length === employeeCampaignDetails.length) {
            setSelectedEmployees([]);
        } else {
            setSelectedEmployees(employeeCampaignDetails.map(employee => employee.id));
        }
    };

    const handleSendSelection = async () => {
        try {
            const body = {
                PolicyId: policy_id,
                RecipientIds: selectedEmployees,
            };
            const response = await axios.put("/api/Flex/sendselectionemails", body);
            if (response.data.success) {
                toastr.success("Email Sent", "Success");
                setShowSendFlexSelectionModal(false);
            } else {
                toastr.error("Failed to send email", "Error");
            }
        } catch (error) {
            toastr.error("Failed to send email", "Error");
        }
    };

    const multiSort = (data, sortConfig) => {
            if (!sortConfig.length) return data;
    
            const sortedData = [...data];
    
            sortedData.sort((a, b) => {
                for (const { field, direction } of sortConfig) {
                    const valueA = a[field] ?? "";
                    const valueB = b[field] ?? "";
    
                    if (valueA < valueB) return direction === "asc" ? -1 : 1;
                    if (valueA > valueB) return direction === "asc" ? 1 : -1;
    
                    // if equal, continue to next sorter
                }
                return 0;
            });
    
            return sortedData;
    };
    const renderSortIndicator = (field) => {
        const sorter =  sortConfig.find(c => c.field === field);
        if (!sorter) return null;

        return (
            <span className="RT-DataTable__header-sort-icon">
                {sorter.direction === "asc" ? <SortDirectionAsc /> : <SortDirectionDesc />}
            </span>
        );
    };

    class SortDirectionDesc extends React.Component {
        render(){
            return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
            <path d="M 12 3 C 11.448 3 11 3.448 11 4 L 11 17.070312 L 7.1367188 13.207031 C 6.7457187 12.816031 6.1126563 12.816031 5.7226562 13.207031 L 5.6367188 13.292969 C 5.2457187 13.683969 5.2457187 14.317031 5.6367188 14.707031 L 11.292969 20.363281 C 11.683969 20.754281 12.317031 20.754281 12.707031 20.363281 L 18.363281 14.707031 C 18.754281 14.316031 18.754281 13.682969 18.363281 13.292969 L 18.277344 13.207031 C 17.886344 12.816031 17.253281 12.816031 16.863281 13.207031 L 13 17.070312 L 13 4 C 13 3.448 12.552 3 12 3 z"></path>
        </svg>
        }
    }
    
    class SortDirectionAsc extends React.Component {
        render(){
            return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
            <path d="M 12 3.3417969 C 11.744125 3.3417969 11.488469 3.4412187 11.292969 3.6367188 L 5.6367188 9.2929688 C 5.2457188 9.6829687 5.2457187 10.316031 5.6367188 10.707031 L 5.7226562 10.792969 C 6.1126563 11.183969 6.7457187 11.183969 7.1367188 10.792969 L 11 6.9296875 L 11 20 C 11 20.552 11.448 21 12 21 C 12.552 21 13 20.552 13 20 L 13 6.9296875 L 16.863281 10.792969 C 17.253281 11.183969 17.886344 11.183969 18.277344 10.792969 L 18.363281 10.707031 C 18.754281 10.317031 18.754281 9.6839688 18.363281 9.2929688 L 12.707031 3.6367188 C 12.512031 3.4412187 12.255875 3.3417969 12 3.3417969 z"></path>
        </svg>
        }
    }
        
    const handleSort = (field) => {
        setSortConfig(prev => {
            const existing = prev.find(c => c.field === field);

            let newSortConfig;

            if (!existing) {
                newSortConfig = [{ field, direction: "asc" }, ...prev];
            } else if (existing.direction === "asc") {
                newSortConfig = prev.map(c =>
                    c.field === field ? { ...c, direction: "desc" } : c
                );
            } else {
                newSortConfig = prev.filter(c => c.field !== field);
            }

            return newSortConfig;
        });
    };

    const handleToggleEmails = async () => {
        try {
            const body = {
                PolicyId: policy_id,
                SelectedEmployees : selectedEmployees,
            };
            const response = await axios.put("/api/Flex/toggleflexemails", body);
            if (response.data.success) {
                toastr.success("Emails Toggled", "Success");
                fetchEmployeeCampaigns();
                setSelectedEmployees([]);
            } else {
                toastr.error("Failed to toggle emails", "Error");
            }
        } catch (error) {
            toastr.error("Failed to toggle emails", "Error");
        }
        setShowAcknowledgmentModal(false);
    };

    const handleDisableEmails = async () => {
        try {
            const body = {
                PolicyId: policy_id,
                SelectedEmployees : selectedEmployees,
            };
            const response = await axios.put("/api/Flex/disableflexemails", body);
            if (response.data.success) {
                toastr.success("Emails Toggled", "Success");
                fetchEmployeeCampaigns();
                setSelectedEmployees([]);
            } else {
                toastr.error("Failed to disable emails", "Error");
            }
        } catch (error) {
            toastr.error("Failed to disable emails", "Error");
        }
        setShowAcknowledgmentModal(false);
    };

    const handleEnableEmails = async () => {
        try {
            const body = {
                PolicyId: policy_id,
                SelectedEmployees : selectedEmployees,
            };
            const response = await axios.put("/api/Flex/enableflexemails", body);
            if (response.data.success) {
                toastr.success("Emails Toggled", "Success");
                fetchEmployeeCampaigns();
                setSelectedEmployees([]);
            } else {
                toastr.error("Failed to enable emails", "Error");
            }
        } catch (error) {
            toastr.error("Failed to enable emails", "Error");
        }
        setShowAcknowledgmentModal(false);
    };

    const sortedEmployees = multiSort(employeeCampaignDetails, sortConfig);
    const currentRecords = sortedEmployees.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );
    const nPages = Math.ceil(employeeCampaignDetails.length / itemsPerPage);

    return (
        <div className="employee-campaigns-container">
            <Card>
                {showBulkEditEmployeeBenCatCampaignModal && (
                    <BulkEditEmployeeBenCatCampaignModal
                        showBulkEditEmployeeBenCatCampaignModal={showBulkEditEmployeeBenCatCampaignModal}
                        bencatOptions={bencatOptions}
                        policyId={policy_id}
                        employeeIds={selectedEmployees}
                        campaignLaunchDate={launchDate}
                        closeBulkEditEmployeeBenCatCampaignModal={() => {
                            setShowBulkEditEmployeeBenCatCampaignModal(false);
                            fetchEmployeeCampaigns();
                            setSelectedEmployees([]);
                        }}
                    />
                )}
                {showBulkEditEmployeeDeadlineCampaignModal && (
                    <BulkEditEmployeeDeadlineCampaignModal
                        showBulkEditEmployeeDeadlineCampaignModal={showBulkEditEmployeeDeadlineCampaignModal}
                        policyId={policy_id}
                        employeeIds={selectedEmployees}
                        selectionDeadline={selectedEmpFlexSelectionDeadline}
                        campaignLaunchDate={launchDate}
                        closeBulkEditEmployeeDeadlineCampaignModal={() => {
                            setShowBulkEditEmployeeDeadlineCampaignModal(false);
                            fetchEmployeeCampaigns();
                            setSelectedEmployees([]);
                        }}
                    />
                )}
                {showEditIndividualEmpCampaignModal && (
                    <EditIndividualEmpCampaignModal
                        showEditIndividualEmpCampaignModal={showEditIndividualEmpCampaignModal}
                        bencatOptions={bencatOptions}
                        policyId={policy_id}
                        employee={selectedIndividualEmployee}
                        campaignSelectionDeadline={selectionDeadline}
                        closeEditIndividualEmpCampaignModal={() => {
                            setShowEditIndividualEmpCampaignModal(false);
                            fetchEmployeeCampaigns();
                            setSelectedEmployees([]);
                        }}
                    />
                )}
                {showSendFlexSelectionModal && (
                    <Modal
                        className="react-modal react-modal-confirm"
                        show={showSendFlexSelectionModal}
                        backdrop="static"
                        keyboard={false}
                    >
                        <Modal.Header className="react-modal-title">
                            <Modal.Title>Acknowledgment</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Card>
                                <span style={{fontSize: 14}}>
                                    Are you sure you want to send a Flex Selection email to the selected employees immediately?
                                </span>
                            </Card>
                        </Modal.Body>
                        <Modal.Footer>
                            <button className="btn btn-secondary" onClick={() => setShowSendFlexSelectionModal(false)}>
                                Cancel
                            </button>
                            <button className="btn btn-primary" onClick={handleSendSelection}>
                                Send
                            </button>
                        </Modal.Footer>
                    </Modal>
                )}
                {showAcknowledgmentModal && (
                    <Modal
                        show={showAcknowledgmentModal}
                        style={{ top: 200 }}
                        centered
                    >
                        <Modal.Header>
                            <Modal.Title style={{ fontSize: 17, fontWeight: 'bold' }}>Acknowledgment</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ maxHeight: 400, overflowY: "auto" }}>
                            <Card>
                                <p>
                                    Disabling selection emails does not exclude employees from flex benefits, 
                                    only from further scheduled emailing. For further assistance, 
                                    contact <a style={{"color":"#0d6efd"}} href="mailto:enrollments@nationalhealthclaim.com">enrollments@nationalhealthclaim.com</a>.
                                </p>
                            </Card>
                        </Modal.Body>
                        <Modal.Footer>
                            <button className="btn btn-secondary" onClick={() => setShowAcknowledgmentModal(false)}>
                                Cancel
                            </button>
                            <button className="btn btn-primary" onClick={handleDisableEmails}>
                                Disable
                            </button>
                            <button className="btn btn-primary" onClick={handleEnableEmails}>
                                Enable
                            </button>
                        </Modal.Footer>
                    </Modal>
                )}
                <div className="bulk-actions-toolbar" style={{ marginBottom: '15px' }}>
                    <button className="btn btn-secondary" onClick={handleSelectAll}>
                        Select/Deselect All
                    </button>
                    <button
                        className="btn btn-primary"
                        onClick={(event) => setShowBulkEditEmployeeBenCatCampaignModal(true)}
                        disabled={disableBtn || selectedEmployees.length === 0 || readOnly}
                        style={{ marginLeft: '10px' }}
                    >
                        Bulk Edit Category
                    </button>
                    <button
                        className="btn btn-primary"
                        onClick={(event) => {setShowBulkEditEmployeeDeadlineCampaignModal(true)}}
                        disabled={disableBtn || selectedEmployees.length === 0 || readOnly}
                        style={{ marginLeft: '10px' }}
                    >
                        Bulk Edit Deadline
                    </button>
                    <button
                        className="btn btn-primary"
                        onClick={() => setShowAcknowledgmentModal(true)}
                        disabled={disableBtn || selectedEmployees.length === 0 || readOnly}
                        style={{ marginLeft: '10px' }}
                    >
                        Toggle Email(s)
                    </button>
                    <button
                        className="btn btn-primary"
                        onClick={() => setShowSendFlexSelectionModal(true)}
                        disabled={disableBtn || selectedEmployees.length === 0 || new Date(launchDate) > new Date() || readOnly}
                        style={{ marginLeft: '10px' }}
                    >
                        Send Manual Email(s)
                    </button>
                </div>
                {loading ? (
                    <div className="pad-container">
                        <Spinner className="pad-spinner" animation="border" variant="primary" />
                    </div>
                ) : (
                    <>
                        <Table hover>
                            <thead>
                            <tr style={{ fontSize: "14px", fontWeight: "bold" }}>
                                <th /> 
                                <th onClick={() => handleSort("lastName")} className="sortable-header">
                                    Last Name {renderSortIndicator("lastName")}
                                </th>

                                <th onClick={() => handleSort("firstName")} className="sortable-header">
                                    First Name {renderSortIndicator("firstName")}
                                </th>

                                <th onClick={() => handleSort("email")} className="sortable-header">
                                    Email {renderSortIndicator("email")}
                                </th>

                                <th onClick={() => handleSort("enableFlexEmails")} className="sortable-header">
                                    Email Notifications Enabled {renderSortIndicator("enableFlexEmails")}
                                    <CustomToolTip
                                        header="Email Notifications Enabled"
                                        bodyContent="Employees will receive all scheduled emails if 'Yes'.
                                                    If 'N/A', the employee does not have flex dollars for the next year
                                                    and will be excluded from all scheduled emailing."
                                    />
                                </th>

                                <th onClick={() => handleSort("name")} className="sortable-header">
                                    Benefit Category {renderSortIndicator("name")}
                                </th>

                                {HasAccrual && (
                                    <th onClick={() => handleSort("isScheduled")} className="sortable-header">
                                        Is Scheduled {renderSortIndicator("isScheduled")}
                                        <CustomToolTip
                                            header="Is Scheduled"
                                            bodyContent="If indicated Yes, employee is assigned to a category with Scheduled Credits 
                                                        and credits will be released incrementally throughout the upcoming year."
                                        />
                                    </th>
                                )}

                                {hasSalaryBaseBenefits && (
                                    <>
                                        <th onClick={() => handleSort("creditCalcMethod")} className="sortable-header">
                                            Limit Calculation Method {renderSortIndicator("creditCalcMethod")}
                                        </th>

                                        <th onClick={() => handleSort("salaryMoney")} className="sortable-header">
                                            Salary {renderSortIndicator("salaryMoney")}
                                        </th>
                                    </>
                                )}

                                <th onClick={() => handleSort("isFlex")} className="sortable-header">
                                    Is Flex {renderSortIndicator("isFlex")}
                                </th>

                                <th onClick={() => handleSort("coverage")} className="sortable-header">
                                    Coverage {renderSortIndicator("coverage")}
                                </th>

                                <th onClick={() => handleSort("flexBase")} className="sortable-header">
                                    Flex Total Limit {renderSortIndicator("flexBase")}
                                </th>

                                <th onClick={() => handleSort("flexSelectionDeadline")} className="sortable-header">
                                    Selection Deadline {renderSortIndicator("flexSelectionDeadline")}
                                </th>

                                {moment(benefitEndDate).isAfter(moment()) && <th />}  
                            </tr>
                            </thead>
                            <tbody>
                            {currentRecords.map(employee => (
                                <tr key={employee.id}>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={selectedEmployees.includes(employee.id)}
                                            onChange={() => {
                                                setSelectedEmployees(prev =>
                                                    prev.includes(employee.id)
                                                        ? prev.filter(id => id !== employee.id)
                                                        : [...prev, employee.id]
                                                );
                                            }}
                                            style={{ marginRight: "10px", marginTop: "2px" }}
                                        />
                                    </td>
                                    <td>{employee.lastName}</td>
                                    <td>{employee.firstName}</td>
                                    <td>{employee.email}</td>
                                    <td>{employee.enableFlexEmails ? 
                                        (employee.isFlex && employee.flexBase > 0 ? "Yes" : "N/A") : "No"}</td>
                                    <td>{employee.name}</td>
                                    {HasAccrual && (<td>{employee.isScheduled ? "Yes" : "No"}</td>)}
                                    {hasSalaryBaseBenefits && (
                                        <>
                                            <td>{employee.creditCalcMethod}</td>
                                            <td>{employee.creditCalcMethod === "SALARY" ? employee.salaryMoney : "N/A"}</td>
                                        </>
                                    )}
                                    <td>{employee.isFlex ? "Yes" : "No"}</td>
                                    <td>{employee.coverage}</td>
                                    <td>{employee.isFlex ? employee.flexBase : "N/A"}</td>
                                    <td>
                                        {employee.flexSelectionDeadline != null ? employee.flexSelectionDeadline.substring(0, 10) : "N/A"}
                                    </td>
                                    {moment(benefitEndDate).isAfter(moment()) && !readOnly &&(
                                        <td>
                                            <a
                                                href="#"
                                                className="RT-Link"
                                                onClick={(event) => {
                                                    setSelectedEmployees([employee.id]);
                                                    setSelectedIndividualEmployee(employee);
                                                    setShowEditIndividualEmpCampaignModal(true);
                                                }}
                                            >
                                                Edit
                                            </a>
                                        </td> 
                                    )}
                                </tr>
                                ))}
                            </tbody>
                        </Table>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "15px" }}>
                            <span className="selected-employees-info" style={{ fontWeight: 500 }}>
                                {`Selected Employees: ${selectedEmployees.length}`}
                            </span>
                            <div className="pagination-container">
                                <div className="pagination-info">
                                    <span>
                                        Showing {currentRecords.length > 0 ? (currentPage - 1) * itemsPerPage + 1 : 0} - {(currentPage - 1) * itemsPerPage + currentRecords.length} entries out of {employeeCampaignDetails.length} entries
                                    </span>
                                </div>
                                <CustomPagination nPages={nPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />
                            </div>
                        </div>
                    </>
                )}
            </Card>
        </div>
    );
};

export default EmployeeCampaignTable;
